














import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class CommonAlert extends Vue {
  private isShow: boolean = false;
  @Prop({default: 'success'})
  private type!: string;

  @Prop({default: ''})
  private text!: string;

  @Prop({default: false})
  private show!: boolean;

  @Prop({default: false})
  private dark!: boolean;

  @Prop({default: ''})
  private prefix?: string;

  @Prop({default: false})
  private dismissible?: boolean;

  @Prop()
  private color?: string;

  @Watch('show')
  watchPropShow() {
    this.isShow = this.show;
  }

  private mounted() {
    this.isShow = this.show;
  }

  private handleClose() {
    this.$emit('close');
  }
}
